import { ACTION_TYPES } from "../../stores/breadcrumbs/breadcrumbsActionTypes";

export const callBreadcrumbAPI = async (token, queryParams = {}, dispatch) => {
  try {
    if (!queryParams)
      console.warn("Breadcrumb API called with EMPTY queryParams.");

    const loadLanIds = queryParams.dirOnly;
    dispatch({
      type: ACTION_TYPES.UPDATE_LOADING,
      payload: loadLanIds ? "breadcrumbLanIds" : "breadcrumbData",
    });
    const queryString = new URLSearchParams(queryParams).toString();
    const requestURL = encodeURI(
      `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/v1/breadcrumb?${queryString}`
    );
    const headers = new Headers({
      Authorization: `Bearer ${token}`,
    });
    const data = await fetch(requestURL, {
      method: "GET",
      headers,
    });

    if (!data.ok) {
      const message = `Breadcrumbs GET failed: ${data.status}`;
      dispatch({
        type: ACTION_TYPES.UPDATE_ERROR,
        payload: { message, errorType: "callBreadcrumbAPI" },
      });
    }
    const breadcrumbData = await data.json();
    return breadcrumbData;
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorCode = isInternalError ? 500 : error.errorCode;
    const errorMessage = isInternalError ? error.toString() : error.message;
    console.log("Error code: " + errorCode);
    console.log("Error msg: " + errorMessage);
    console.log("Stack trace: " + error.stack);
    dispatch({
      type: ACTION_TYPES.UPDATE_ERROR,
      payload: {
        message: errorMessage + ` Error code: ${errorCode}`,
        errorType: "callBreadcrumbAPI",
      },
    });
    return null;
  }
};
